export function index() {
    return axios.get(route('api.manage.companies.booster.index') + '?all=true')
        .then(({data}) => data);
}

export function requestIntegration(userId, data) {
    return axios.post(route('api.manage.companies.booster.integration', {userId: userId}), data)
        .then(response => response.data);
}

export function requestBooster(userId, data) {
    return axios.post(route('api.manage.companies.booster.request', {userId: userId}), data)
        .then(({data}) => data);
}

